
















import { Component, Vue, Prop } from "vue-property-decorator";
const cityData = require("@/assets/pca-code.json");
@Component({})
export default class ProjectZiduanJiatingzhuzhi extends Vue {
  private cityOption: any;
  private defaultValue: any[] = [];
  private defaultValue2: string = "";
  /**
   * @description 加载三级联动数据，加载缓存的验证码等待时间
   */
  private beforeMount() {
    this.cityOption = cityData;
  }
}
